import createAction from "../../app/createAction";
import { OPEN_NOTIFICATION } from "./notificationsConstants";

export const openNotificationAction = (payload) => createAction(OPEN_NOTIFICATION, payload);
